import React, { useState, useEffect, useCallback } from 'react';
import {
  Box, Flex, Heading, Table, Thead, Tbody, Tr, Th, Td,
  Badge, IconButton, Spinner, Text,
} from '@chakra-ui/react';
import { FiRefreshCw } from 'react-icons/fi';

const ACTION_COLORS = {
  room_created: 'green',
  room_deleted: 'red',
  room_updated: 'blue',
  session_started: 'teal',
  session_ended: 'orange',
  participant_joined: 'cyan',
  participant_left: 'gray',
  api_key_created: 'purple',
  api_key_revoked: 'red',
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem('meet_token');
  const headers = { 'Authorization': `Token ${token}` };

  const fetchLogs = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/v1/audit-logs/', { headers });
      if (res.ok) setLogs(await res.json());
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchLogs(); }, [fetchLogs]);

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={6}>
        <Heading size="lg" color="gray.700">Audit Log</Heading>
        <IconButton icon={<FiRefreshCw />} onClick={fetchLogs} variant="ghost" aria-label="Refresh" />
      </Flex>

      {loading ? (
        <Flex justify="center" py={12}><Spinner size="lg" color="teal.500" /></Flex>
      ) : (
        <Box bg="white" borderRadius="xl" boxShadow="sm" overflow="hidden">
          <Table size="sm">
            <Thead bg="gray.50">
              <Tr>
                <Th>Action</Th>
                <Th>Actor</Th>
                <Th>Resource</Th>
                <Th>Time</Th>
              </Tr>
            </Thead>
            <Tbody>
              {logs.map((log) => (
                <Tr key={log.id} _hover={{ bg: 'gray.50' }}>
                  <Td>
                    <Badge colorScheme={ACTION_COLORS[log.action] || 'gray'} fontSize="xs">
                      {log.action.replace(/_/g, ' ')}
                    </Badge>
                  </Td>
                  <Td fontSize="sm" color="gray.600">{log.actor || '—'}</Td>
                  <Td fontSize="sm" color="gray.500">
                    {log.resource_type && <Text>{log.resource_type} #{log.resource_id}</Text>}
                  </Td>
                  <Td fontSize="xs" color="gray.400">
                    {new Date(log.created_at).toLocaleString()}
                  </Td>
                </Tr>
              ))}
              {logs.length === 0 && (
                <Tr><Td colSpan={4} textAlign="center" py={8} color="gray.400">No audit logs yet</Td></Tr>
              )}
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  );
}
